export interface AnnouncementDismissal {
  id: string;
  resetKey: string;
  dismissed: boolean;
}

export function inAppAnnouncementStorageKey({
  userId,
  announcement,
}: {
  userId: string;
  announcement: Pick<AnnouncementDismissal, "id" | "resetKey">;
}) {
  return `replo.announcement.${userId}.${announcement.id}.${announcement.resetKey}`;
}

export function undismissedInAppAnnouncements<
  Announcement extends AnnouncementDismissal,
>({
  announcements,
  userId,
  storage,
}: {
  announcements: Announcement[];
  userId: string;
  storage: Pick<Storage, "getItem">;
}): Announcement[] {
  const available = announcements.filter(
    (announcement) => !announcement.dismissed,
  );
  try {
    return available.filter((announcement) => {
      return (
        storage.getItem(
          inAppAnnouncementStorageKey({ userId, announcement }),
        ) !== "dismissed"
      );
    });
  } catch (error) {
    // Blocked storage falls back to the server-side dismissed flag alone.
    if (!(error instanceof DOMException)) {
      throw error;
    }
    return available;
  }
}

export function dismissInAppAnnouncement({
  announcement,
  userId,
  storage,
}: {
  announcement: Pick<AnnouncementDismissal, "id" | "resetKey">;
  userId: string;
  storage: Pick<Storage, "setItem">;
}) {
  storage.setItem(
    inAppAnnouncementStorageKey({ userId, announcement }),
    "dismissed",
  );
}
